import {lazy} from 'react';

export const NewsConfigLazy = lazy(() => import(/* webpackChunkName: "newsConfig" */ '.'));
